import React from 'react';
import './Line.less';

export interface ILineProps {}
type Props = ILineProps;

export function Line(props: Readonly<Props>) {
  return <div className="common-presenter k-common-line" />;
}

export default Line;
